import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { IVehicleData, IVehiclesData } from '../../components/Vehicles/types';

export const vehiclesDataAtom = atom<IVehiclesData>({});

export const vehicleDataByIdAtomFamily = atomFamily((vehicleId: number | false) =>
  atom<IVehicleData | null>((get) => {
    if (!vehicleId) return null;
    const vehicles = get(vehiclesDataAtom);
    return vehicles[vehicleId] ?? null;
  })
);

/** Alias for migration from Recoil */
export const vehicleDataByIdSelector = vehicleDataByIdAtomFamily;
